import { Id } from './core';

export interface User {
  id: Id;
  username: string;
  email: string;
  role: 'user' | 'root';
}
